/**
 * @param {object} props
 * @param {{ title: string, completed: number, required: number }} props.bar
 * @returns {React.Component}
 */
export default function StatusBar({ bar }) {
  const widthPercent = (bar.completed / bar.required) * 100;
  const isFilled = bar.completed >= bar.required;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row justify-between">
        <span className="text-white text-sm">{bar.title}</span>
        <span className="text-c-gray-400 text-sm">
          {bar.completed} / {bar.required}
        </span>
      </div>
      <div className="h-2.5 rounded-full bg-c-gray-500">
        <div
          className="h-2.5 rounded-full transition-all"
          style={{
            width: `${Math.min(widthPercent, 100)}%`,
            backgroundColor: isFilled ? "#fcd86a" : "#805bea",
          }}
        />
      </div>
    </div>
  );
}
